import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a Search icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/magnifying-glass?f=classic&s=solid
 */
export const SearchIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faMagnifyingGlass} {...props} />;
};
